import React, {useEffect, useState} from 'react'
import {Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {LoginUsuario} from './pages/Login/LoginUsuario'
import {RestorePassword} from './pages/OlvidoPass/RestorePassword'
import {UserRequest} from './modules/UserRequest'
import {CheckYourEmail} from './modules/CheckYourEmail'
import {CategoriesClient} from './modules/CategoriesClient'
import {HistoryInvoice} from './modules/HistoryInvoice'
import {MyGlobalContext} from './context/helpersProvider'
import {ToastBase} from './components/Toast/ToastBase'
import {Loader} from './components/Loader'
import {Component404} from './modules/404'
import VisualizacionFactura from './pages/DetalleFactura/VisualizacionFactura'
import CrearCuentaIndex from './pages/CrearCuenta/CrearCuentaIndex.page'
import ModalError from './components/Modals/ModalError/ModalError'
import {useDispatch, useSelector} from 'react-redux'
import {State} from './reducers'
import {LoaderRedux} from './components/LoaderRedux'
import ModalInfo from './components/Modals/ModalInfo/ModalInfo'
import ModalMessage from './components/Modals/Generales/ModalMessage'
import EmitirFacturaIndex from './pages/EmitirFactura/EmitirFacturaIndex.page'
import RestablecerEmail from './pages/OlvidoPass/RestablecerEmail.page'
import CodigoVerificacion from './pages/OlvidoPass/CodigoVerificacion.page'
import PrivateRoute from './routes/PrivateRoute'
import PublicRoute from './routes/PublicRoute'
import Home from './pages/Home/Home.page'
import OtrosDocumentosIndex from './pages/OtrosDocumentos/OtrosDocumentosIndex.page'
import EmitirDocumentoIndex from './pages/OtrosDocumentos/EmitirDocumento.page'
import GUDashboard from './pages/GestionUsuarios/Dashboard/GUDashboard.page'
import CrearUsuarioIndex from './pages/GestionUsuarios/CrearUsuario/CrearUsuarioIndex.page'
import ListaUsuario from './pages/GestionUsuarios/ListaUsuarios/ListaUsuario.page'
import EstadoDocumento from './pages/GestionUsuarios/EstadoDocumentos/EstadoDocumento.page'
import EditarUsuario from './pages/GestionUsuarios/EditarUsuario/EditarUsuario'
import UserIndex from './pages/Usuario/UserIndex.page'
import Liquidacion from './pages/OtrosDocumentos/Liquidacion'
import LiquidacionDetalle from './pages/OtrosDocumentos/LiquidacionDetalle'
import FacturaExportacion from './pages/OtrosDocumentos/FacturaExportacion'
import ExportacionDetalle from './pages/OtrosDocumentos/ExportacionDetalle'
import SujetoExcluidoIndex from './pages/SujetoExcluido/SujetoExcluidoIndex.page'
import SuscripcionIndex from './pages/Suscripcion/SuscripcionIndex.page'
import ModalErrorSuscripcion from './components/Modals/ModalError/ModalErrorSuscripcion'
import CodigoVerificacionCC from './pages/CrearCuenta/Components/6CodigoVerificacionCC'
import ConfirmacionCuenta from './pages/ConfirmarCuenta/ConfirmacionCuenta'
import {RestorePasswordUser} from './pages/OlvidoPass/RestorePasswordUser'
import AlertToast from './components/Toast/AlertToast'
import CreditoFiscal from './pages/OtrosDocumentos/CreditoFiscal'
import ModalInfoSuscripcion from './components/Modals/ModalLimite/ModalLimite'
import NotaRemision from './pages/OtrosDocumentos/NotaRemision'
import NotaCredito from './pages/OtrosDocumentos/NotaCredito'
import NotaDebito from './pages/OtrosDocumentos/NotaDebito'
import { getBotonesAyuda } from './actions/catalogos.actions'
import SesionCaducada from './pages/SesionCaducada/SesionCaducada.page'
import { RefreshToken, RefreshTokenCore, clearDataRedux } from './actions/userLogin.actions'
import ModalConfirmEdicion from './components/Modals/Generales/ModalConfirmEdicion'
import ComprobanteRetencionIndex from './pages/ComprobanteRetencion/ComprobanteRetencionIndex.page'
import { KEYS, VERSION } from './constants/keysStorage'
import ComprobanteLiquidacion from './pages/OtrosDocumentos/ComprobanteLiquidacion'
import DocumentoLiquidacion from './pages/OtrosDocumentos/DocumentoLiquidacion'
import NotaDebitoExterno from './pages/OtrosDocumentos/NotaDebitoExterno'
import NotaCreditoExterno from './pages/OtrosDocumentos/NotaCreditoExterno'
import Horarios from './pages/GestionUsuarios/Horarios/Horarios.page'
import MasOpcionesIndex from './pages/MasOpciones/MasOpcionesIndex.page'
import CierrePeriodoFiscal from './pages/MasOpciones/CierrePeriodoFiscal.page'
import BitacoraCorreos from './pages/MasOpciones/BitacoraCorreos.page'
import LibroVentas from './pages/MasOpciones/LibroVentas.page'
import LibroVentasConsulta from './pages/MasOpciones/LibroVentasConsulta.page'
import LibroCompras from './pages/MasOpciones/LibroCompras.page'
import LibroComprasNuevo from './pages/MasOpciones/LibroComprasNuevo.page'
import LibroComprasDetalle from './pages/MasOpciones/LibroComprasDetalle.page'

function App() {
  const open: boolean = useSelector((state: State) => state.general.modalError.open)
  const openInfo: boolean = useSelector((state: State) => state.general.modalInfo.open)
  const openMessage: boolean = useSelector((state: State) => state.general.modalMessage.open)
  const openToast: boolean = useSelector((state: State) => state.general.toast.open)
  const openLimite: boolean = useSelector((state: State) => state.general.modalLimite.open)
  const {botonesAyuda} = useSelector((state: State) => state.catalogos)
  const modalSuscripcion: boolean = useSelector((state: State) => state.general.modalSuscripcion.open)
  const loader: boolean = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()
  const [showLoading, setShowLoading] = useState<string>('false')
  const [showToast, setShowToast] = useState<toast>({
    open: 'false',
    type: '',
    message: '',
  })

  interface toast {
    open: string
    type: string
    message: string
  }

  useEffect(() => {
    ResetCache();
    if(!botonesAyuda){
      dispatch(getBotonesAyuda())
    }
  }, [])
  
  useEffect(() => {
    let ExcludePtah = [
      '/sesion-caducada',
      '/account-confirm2',
      '/create',
      '/request',
      '/forgot',
      '/verify',
      '/user-restore',
      '/restore/:code?',
      '/check',
      '/account-confirm',
    ]
    let AllowedWithoutSubscription = [
      '/sesion-caducada',
      '/account-confirm2',
      '/create',
      '/request',
      '/forgot',
      '/verify',
      '/user-restore',
      '/restore/:code?',
      '/check',
      '/account-confirm',
      '/home',
      '/suscripcion/info',
      '/suscripcion/factura',
      '/user/profile',
    ]
    // Validar usuario activo y Refresh Token
    if(!ExcludePtah.includes(window.location.pathname)){
      RefreshToken()
      //RefreshTokenCore()
    }
    
    if(!AllowedWithoutSubscription.includes(window.location.pathname) && localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'){
      window.location.replace("/home")
    }

  }, [window.location.pathname])

  const ResetCache = () =>{
    let versionAPP = localStorage.getItem(VERSION);
    if(process.env.REACT_APP_VERSION !== versionAPP) clearStorage();    
  }
  const clearStorage = () => {
    dispatch(clearDataRedux())
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(VERSION, process.env.REACT_APP_VERSION || "");
    window.location.replace("/")
  }

  return (
    <React.Fragment>
      <MyGlobalContext.Provider value={{showLoading, showToast, setShowLoading, setShowToast}}>
        <Switch>
          {/* -------------------- Rutas sin necesidad de estar Logueado --------------------*/}
          {/* Login */}
          <PublicRoute exact path='/' component={LoginUsuario} />

          {/* Flujo creación de cuenta */}
          <PublicRoute exact path='/create' component={CrearCuentaIndex} />
          <PublicRoute exact path='/request' component={UserRequest} />

          {/* Flujo olvido su contraseña */}
          <PublicRoute exact path='/forgot' component={RestablecerEmail} />
          <PublicRoute exact path='/verify' component={CodigoVerificacion} />
          <PublicRoute exact path='/user-restore' component={RestorePasswordUser} />
          <PublicRoute path='/restore/:code?' component={RestorePassword} />

          <Route exact path='/check' component={CheckYourEmail} />

          <PublicRoute exact path='/account-confirm' component={CodigoVerificacionCC} />
          <PublicRoute exact path='/account-confirm2' component={ConfirmacionCuenta} />

          {/* -------------------- Rutas donde el usuario debe estar logueado --------------------*/}
          {/* Rutas con Login */}
          <PrivateRoute exact path='/home' component={Home} />
          <PrivateRoute exact path='/preferences' component={CategoriesClient} />
          <PrivateRoute exact path='/user/profile' component={UserIndex} />

          {/* Historial de documentos */}
          <PrivateRoute exact path='/history-invoice' component={HistoryInvoice} />
          <PrivateRoute exact path='/history-invoice/detail' component={VisualizacionFactura} />

          {/* Facturación -Emision de Factura */}
          <PrivateRoute path='/emitir-factura' component={EmitirFacturaIndex} />

          {/* Gestion de Usuarios */}
          <PrivateRoute exact path='/gestion-usuarios' component={GUDashboard} />
          <PrivateRoute
            exact
            path='/gestion-usuarios/crear-usuario'
            component={CrearUsuarioIndex}
          />
          <PrivateRoute exact path='/gestion-usuarios/horarios' component={Horarios} />
          <PrivateRoute exact path='/gestion-usuarios/listar-usuarios' component={ListaUsuario} />
          <PrivateRoute
            exact
            path='/gestion-usuarios/estado-documentos'
            component={EstadoDocumento}
          />
          <PrivateRoute exact path='/gestion-usuarios/editar-usuario' component={EditarUsuario} />

          {/* Otros documentos */}
          <PrivateRoute exact path='/otros-documentos' component={OtrosDocumentosIndex} />
          <PrivateRoute path='/otros-documentos/emitir' component={EmitirDocumentoIndex} />
          <PrivateRoute
            exact
            path='/otros-documentos/factura-exportacion'
            component={FacturaExportacion}
          />
          <PrivateRoute
            exact
            path='/otros-documentos/factura-exportacion/detalle'
            component={ExportacionDetalle}
          />

          {/* Factura Sujeto Excludio */}
          <PrivateRoute path='/otros-documentos/sujeto-excluido' component={SujetoExcluidoIndex} />

          {/* Suscripcion */}
          <PrivateRoute path='/suscripcion' component={SuscripcionIndex} />
          {/* Credito Fiscal */}
          <PrivateRoute path = '/otros-documentos/credito-fiscal' component={CreditoFiscal}/>
          {/* Nota Remision */}
          <PrivateRoute path = '/otros-documentos/nota-remision' component={NotaRemision}/>
          {/* Nota Credito */}
          <PrivateRoute path = '/otros-documentos/nota-credito' component={NotaCredito}/>
          {/* Nota Debito */}
          <PrivateRoute path = '/otros-documentos/nota-debito' component={NotaDebito}/>
          <PrivateRoute path = '/otros-documentos/nota-debito-externo' component={NotaDebitoExterno}/>
          {/* Comprobante Liquidacion */}
          <PrivateRoute path = '/otros-documentos/comprobante-liquidacion' component={ComprobanteLiquidacion}/>
          {/* Liquidacion */}
          <PrivateRoute path = '/otros-documentos/liquidacion' component={DocumentoLiquidacion}/>
          {/* Comprobante de retención */}
          <PrivateRoute path='/otros-documentos/comprobante-retencion' component={ComprobanteRetencionIndex} />
          {/* Nota Credito Externo*/}
          <PrivateRoute path = '/otros-documentos/nota-credito-externo' component={NotaCreditoExterno}/>
          {/* Mas Opciones */}
          <PrivateRoute exact path='/mas-opciones' component={MasOpcionesIndex}/>
          {/* Cierre periodo fiscal */}
          <PrivateRoute path='/mas-opciones/cierre-periodo-fiscal' component={CierrePeriodoFiscal}/>
          {/* Bitacora correos */}
          <PrivateRoute path='/mas-opciones/bitacora-correos' component={BitacoraCorreos}/>
          {/* Libro IVA ventas */}
          <PrivateRoute path='/mas-opciones/libro-ventas' component={LibroVentas}/>
          <PrivateRoute path='/mas-opciones/libro-ventas-consulta' component={LibroVentasConsulta}/>
          {/* Libro IVA Compras */}
          <PrivateRoute path='/mas-opciones/libro-compras' component={LibroCompras}/>
          <PrivateRoute path='/mas-opciones/libro-compras-nuevo' component={LibroComprasNuevo}/>
          <PrivateRoute path='/mas-opciones/libro-compras-detalle' component={LibroComprasDetalle}/>

          {/* ------------------------ Rutas no definidas --------------------------- */}
          <Route path="/sesion-caducada" component={SesionCaducada} />
          <Route path={'/404'} component={Component404} />
          <Route path='*' component={Component404} />
        </Switch>
        <ToastBase />
        <Loader />
        {open && <ModalError />}
        {openInfo && <ModalInfo />}
        {openMessage && <ModalMessage />}
        {loader && <LoaderRedux />}
        {modalSuscripcion && <ModalErrorSuscripcion />}
        {openToast && <AlertToast />}
        {openLimite && <ModalInfoSuscripcion/>}
        <ModalConfirmEdicion/>
      </MyGlobalContext.Provider>
    </React.Fragment>
  )
}

export default App
